
<style scoped lang="less">
.box {
    height: 1450px;
}
.box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    height: 1550px;
    width: 100vw;
    background-image: url('http://static.unicornselected.com/FmwlcP8H5Q407hW3WZnnyMS99d26');
    background-size: 100% 100%;
}

.head-wrapper {
    color: white;
    .cover {
        position: relative;
        height: 370px;
        .circel {
            // background-image: url(http://static.unicornselected.com/FvWpsjBWZCCtu-05S457QV7OEyWd);
            // background-size: 100% 100%;
            position: relative;
            top: 40px;
            margin: 0 auto;
            width: 350px;
            height: 255px;

            .introduce {
                position: relative;
                top: 65px;
                .aboutOur {
                    margin: 0 auto;
                    position: relative;
                    bottom: 5px;
                    // width: 135px;

                    .aboutUs {
                        // border-bottom: 2px solid #fff;
                    }
                    > span {
                        font-size: 36px;
                    }
                }
                .text1 {
                    display: inline-block;
                    width: 300px;
                }
                .text {
                    display: inline-block;
                    .reds {
                        font-size: 16px;
                        font-weight: 500;
                        color: #bc242b;
                    }
                }

                .english {
                    font-size: 15px;
                }
            }
        }
    }
    .cover::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        height: 370px;
        width: 100vw;
        background-image: url('http://static.unicornselected.com/b45017f0-0335-11eb-91c5-d550a48abe82.jpeg');
        background-size: 100% 100%;
        filter: brightness(0.6);
    }
}
.content-wrapper {
    position: relative;
    .card {
        color: #999;
        margin: 0 auto;
        width: 600px;
        height: 250px;
        border-radius: 6px;
        top: -40px;
        box-shadow: 0px 10px 19px rgb(221, 230, 240);
        display: flex;
        flex-direction: column;
        justify-content: center;
        > img {
            margin: 0 auto;
            width: 150px;
            position: relative;
            top: -30px;
        }
        > .text1 {
            position: relative;
            top: -10px;
            margin: 0 auto;
            width: 280px;
            text-align: left;
            display: inline-block;
            font-size: 15px;
        }
        > .text2 {
            position: relative;
            top: 10px;
            left: 10px;
            text-align: left;
            margin: 0 auto;
            width: 300px;
            font-size: 19px;
            display: inline-block;
        }
    }
}

.icon-right-big {
    font-size: 40px;
    border-radius: 50px;
    padding: 5px;
    background-color: rgba(208, 226, 248, 1);
}
.icon-left-big {
    font-size: 40px;
    border-radius: 50px;
    padding: 5px;
    background-color: rgba(208, 226, 248, 1);
}

.myTeam {
    position: relative;
    top: 100px;
    margin: 0 auto;
    width: 200px;
    height: 50px;
    // background-color: red;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .line {
        width: 40px;
        height: 1px;
        background-color: #999;
    }
    .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .text1 {
            font-size: 16px;
        }
        .text2 {
            font-weight: 800px;
            font-size: 12px;
            color: #999;
        }
    }
}

.lunboBtn {
    width: 50px;
}
.lunbo {
    width: 1000px;
    height: 510px;
    margin: 0 auto;
    // background-color: red;
    margin-top: 100px;
    overflow: hidden;
    overflow-x: 'hidden';
    overflow-y: 'hidden';
    position: relative;
    .lunbo-right-btn {
        position: absolute;
        top: 250px;
        left: 840px;
        display: inline-block;
    }
    .lunbo-left-btn {
        position: absolute;
        display: inline-block;
        left: 110px;
        top: 255px;
    }

    .lunbo-content-controller {
        margin: 0 auto;
        // background-color: orange;
        width: 600px;
        overflow: hidden;
        .lunbo-layout::-webkit-scrollbar {
            display: none;
        }

        .lunbo-layout {
            overflow: auto;
            height: 500px;
            width: 800px;
            overflow-x: hidden;
            overflow-y: auto;
            .lunbo-box-controller {
                margin-top: 100px;
                white-space: nowrap;
                transition: all 0.5s;
                .lunbo-box {
                    border-radius: 5px;
                    overflow: hidden;
                    width: 200px;
                    height: 250px;
                    border-radius: 5px;
                    white-space: nowrap;
                    display: inline-block;
                    transition: all 0.5s;
                    position: relative;
                    img {
                        margin: 0 auto;
                        height: 250px;
                        width: 200px;
                    }
                    .lunbo-text {
                        background: rgba(0, 0, 0, 0.192);
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        padding: 0 15px;
                        .names {
                            text-align: left;
                            color: #fff;
                            margin-top: 3px;
                        }
                        .texts {
                            color: #fff;
                            font-size: 10px;
                            text-align: left;
                            word-break: break-all;
                            white-space: nowrap;
                        }
                    }
                }
                .lunbo-active {
                    transform: scale(1.5);
                    -webkit-transform: scale(1.5) rotate(0deg);
                    -moz-transform: scale(1.5) rotate(0deg);
                    -o-transform: scale(1.5) rotate(0deg);
                    position: relative;
                    z-index: 2;
                }
                .lunbo-active .names {
                    position: relative;
                    // left: 20px;
                }
                .lunbo-active .texts {
                    transform: scale(0.76);
                    -webkit-transform: scale(0.76) rotate(0deg);
                    -moz-transform: scale(0.76) rotate(0deg);
                    -o-transform: scale(0.76) rotate(0deg);
                    position: relative;
                    left: -20px;
                }
                .lunbo-active1 {
                    position: relative;
                    z-index: 1;
                    // bottom: 30px;
                }
            }
        }
    }
}
.business-btn {
    position: relative;
    top: -50px;
    // left: 50px;
    width: 220px;
    margin: 0 auto;
    .buy-btn {
        display: inline-block;
        width: 200px;
        height: 40px;
        background: #bc242b;
        border-radius: 50px;
        span {
            color: #fff;
            line-height: 40px;
        }
    }
}
.footer {
    margin-top: 10px;
}
.agreement {
    overflow-y: auto;
    height: 1000px;
    width: 1000px;
    margin: 50px auto;
    // background-color: aqua;
    font-size: 1px;
}
</style>

<template>
    <div class="box">
        <div class="head-wrapper">
            <div class="cover">
                <div class="circel">
                    <div class="introduce">
                        <div class="aboutOur">
                            <span class="aboutUs">平台协议</span>
                            <div class="english">
                                <span class="tnr">Agreement</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="agreement">
            <div
                v-for="(item, index) in items"
                :key="index"
            >
                <img
                    :src="item"
                    alt
                >
            </div>
        </div>
        <bottom class="footer"></bottom>
    </div>
</template>

<script>
import Bottom from '../components/bottom';
export default {
    components: {
        Bottom,
    },
    computed: {
        items() {
            if (location.pathname.indexOf('/en') >= 0) {
                return [
                    'http://static.unicornselected.com/41c307d0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/498fa4a0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/548e95a0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/586b3390-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/5bf56bc0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/5f898f00-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/63f94530-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/6816bcb0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/6bacb4b0-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/6fe81470-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/7354b280-17ed-11ea-8643-8db5f30343de.jpg',
                    'http://static.unicornselected.com/76ca9f60-17ed-11ea-8643-8db5f30343de.jpg',
                ];
            } else {
                return [
                    'http://static.unicornselected.com/b491b4d0-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b5029f10-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b541caf0-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b58a45a0-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b5df6a80-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b6288170-0335-11eb-91c5-d550a48abe82.jpeg',
                    'http://static.unicornselected.com/b65dc240-0335-11eb-91c5-d550a48abe82.jpeg',
                ];
            }
        },
    },
    data() {
        return {};
    },
};
</script>
